var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-email-pill"},[_c('Avatar'),_c('span',{staticClass:"email"},[_vm._v(_vm._s(_vm.email))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }